import React from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Logo from '../../images/logo.svg';
import arabicBg from '../../images/arabic-bg-dark.svg';
import './style.css';

const VerifyEmailNoticePage = () => {
    const { t } = useTranslation();

    return (
        <div className="verify-notice-page">
            {/* Arabic Background Pattern */}
            <div className="verify-notice-bg-pattern" style={{ backgroundImage: `url(${arabicBg})` }} />

            {/* Header */}
            <div className="verify-notice-header">
                <Link to="/" className="verify-notice-logo">
                    <img src={Logo} alt={t('verifyEmail.logoAlt')} />
                </Link>
            </div>

            {/* Main Content */}
            <div className="verify-notice-content">
                <div className="verify-notice-card">
                    {/* Animated Email Icon */}
                    <div className="email-icon-wrapper">
                        <FaEnvelope className="email-icon" />
                        <div className="email-pulse"></div>
                    </div>

                    <h1>{t('verifyEmail.checkEmail')}</h1>

                    <p className="verify-main-text">
                        {t('verifyEmail.sentVerificationLink')}
                        {' '}
                        {t('verifyEmail.checkInbox')}
                    </p>

                    {/* Info Boxes */}
                    <div className="verify-info-boxes">
                        <div className="info-box">
                            <FaCheckCircle className="info-icon success" />
                            <p>{t('verifyEmail.clickLink')}</p>
                        </div>
                        <div className="info-box">
                            <FaExclamationTriangle className="info-icon warning" />
                            <p>{t('verifyEmail.checkSpam')}</p>
                        </div>
                    </div>

                    {/* Actions */}
                    <div className="verify-notice-actions">
                        <Link to="/login" className="btn-primary">
                            {t('verifyEmail.goToLogin')}
                        </Link>
                        <Link to="/" className="btn-secondary">
                            {t('verifyEmail.backToHome')}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyEmailNoticePage;
